const Error = ({ message }) => {
    return (
      <div className="bg-danger text-white text-center p-2 uppercase mb-3 rounded">
        <p style={{ margin: 0}}>{message}</p>
      </div>
    );
  };
  
  export default Error;